import './helpers.mjs';
import './config.mjs';
import { b as registerComponent, u as use } from './plugins-a4da84c4.mjs';
import './Icon-76d58102.mjs';
import './MatchMediaMixin-2d99700d.mjs';
import { _ as __vue_component__, a as __vue_component__$1 } from './Pagination-491183e7.mjs';
export { _ as OPagination, a as OPaginationButton } from './Pagination-491183e7.mjs';

const Plugin = {
  install(Vue) {
    registerComponent(Vue, __vue_component__);
    registerComponent(Vue, __vue_component__$1);
  }

};
use(Plugin);

export default Plugin;
